import { edWebkitTheme } from "@trailblazer-game/ed-webkit";

let _theme = edWebkitTheme;
_theme.header.height.sm = '80px';
export const theme = _theme;